import View from './View'
import Search from './Search'
import pages from './View/pages'

export default {
  View,
  Search,
  pages
}
